import type { TagColor } from '@fundline/shared/schemas/fields';
import type { ReactNode } from 'react';
import type { BadgeRole } from './Badge.tsx';

/**
 * Tags keep the colour chosen for them, shown through the brand's five badge roles (brand kit: every
 * custom label maps to one of them).
 */
export const TAG_COLOR_ROLES: Record<TagColor, BadgeRole> = {
  gray: 'neutral',
  red: 'declined',
  pink: 'declined',
  orange: 'pending',
  amber: 'pending',
  green: 'funded',
  teal: 'funded',
  blue: 'new',
  indigo: 'new',
  purple: 'new',
};

export function tagRole(color: string): BadgeRole {
  return TAG_COLOR_ROLES[color as TagColor] ?? 'neutral';
}

/** A tag label. `action` renders inside the chip (e.g. a remove button). */
export function TagChip({
  name,
  color,
  action,
}: {
  name: string;
  color: string;
  action?: ReactNode;
}) {
  return (
    <span className={`fl-badge fl-badge--${tagRole(color)} max-w-full`} data-testid="tag-chip">
      <span className="truncate">{name}</span>
      {action}
    </span>
  );
}
